var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{fixed: _vm.fixed},style:([_vm.position, _vm.backgroundColor,_vm.zIndex]),attrs:{"id":"lm-component-loading"}},[_c('img',{attrs:{"src":require("@/assets/images/LmComponentLoading.svg"),"alt":"loading"}})])}
var staticRenderFns = []

export { render, staticRenderFns }